module.exports = __webpack_public_path__ + "static/media/data.72ed5715.mp4";